import Config from '../../../../config';
import {
  handleErrors,
  parseAsJson,
} from '../../../../utils/requestHelpers';
import fetch from '../../../../utils/fetchService';

export const fetchReleaseNotes = async () => await fetch(
  Config.endpoints.RELEASE_NOTES
)
  .then(handleErrors({ errorMessage: 'Fetching release notes failed' }))
  .then(parseAsJson);
